export default __webpack_public_path__ + "static/media/SendMethod.73b96e25.svg";